import { render, staticRenderFns } from "./TopicCreate.vue?vue&type=template&id=d76f334c"
import script from "./TopicCreate.vue?vue&type=script&lang=js"
export * from "./TopicCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports